<template>
    <el-dropdown placement="top-start" trigger="click">
        <span class="el-dropdown-link">
            <img class="icon pointer" src="@/assets/sticker.png" alt="贴纸" title="贴纸">
        </span>
        <el-dropdown-menu slot="dropdown" class="picker-dropdown">
            <div class="picker-container">
                <div class="tabs-container">
                    <el-tabs v-model="activeTabIndex" class="picker-tabs" @tab-click="handleTabClick" :stretch="false">
                        <el-tab-pane v-for="(item, index) in tabList" :key="index" :name="index + ''">
                            <span slot="label">
                                <img v-if="item.name === 'lmyHistory'"
                                    :src="require('@/assets/icon/' + (activeTabIndex === String(index) ? 'historyActIcon.png' : 'historyIcon.png'))"
                                    style="width:28px;height:28px;vertical-align:middle;object-fit:contain;">
                                <img v-else-if="item.stickers && item.stickers.length > 0" :src="item.stickers[0].url"
                                    style="width:28px;height:28px;vertical-align:middle;object-fit:contain;">
                            </span>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="content-container">
                    <div class="sticker-grid">
                        <div v-for="(item, index) in currentStickers" :key="index" class="sticker-item"
                            @click="onStickerClick(item)">
                            <img class="sticker-image" :src="item.url" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    name: 'StickerPicker',
    props: {
        // 简化的数据结构: [{ name: 'category1', stickers: [{url: 'xx', ...}] }]
        stickersList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activeTabIndex: '0'
        }
    },
    computed: {
        tabList() {
            return this.stickersList || [];
        },
        currentStickers() {
            const index = parseInt(this.activeTabIndex);
            return this.tabList[index]?.stickers || [];
        }
    },
    methods: {
        handleTabClick(tab) {
            this.activeTabIndex = tab.name;
        },
        onStickerClick(sticker) {
            this.$emit('sticker-select', sticker);
        }
    }
}
</script>

<style lang="scss" scoped>
.icon {
    width: 22px;
    height: 22px;
    margin-right: 20px;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.picker-dropdown {
    width: 420px;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border: 1px solid #e4e7ed;
    overflow: hidden;
}

.picker-container {
    background: #fff;
}

.tabs-container {
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    padding: 8px;
}

.picker-tabs {
    ::v-deep .el-tabs__header {
        margin: 0;
        border: none;
    }

    ::v-deep .el-tabs__nav-wrap {
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;
        border: none;
        position: relative;
        height: 48px;
        display: flex;
        align-items: center;
        padding: 0 30px;

        &::-webkit-scrollbar {
            display: none;
        }

        &::after {
            height: 0;
        }
    }

    ::v-deep .el-tabs__nav {
        border: none;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 0 4px;
    }

    ::v-deep .el-tabs__item {
        min-width: 40px;
        height: 40px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background: transparent;
        margin: 0 2px;
        border-radius: 8px;
        transition: all 0.2s ease;
        position: relative;

        &:hover {
            background: #f0f0f0;
        }

        &.is-active {
            background: transparent;
            color: inherit;
            border-bottom: none;
        }

        &.is-active::after {
            content: '';
            display: block;
            position: absolute;
            left: 20%;
            right: 20%;
            bottom: 0;
            height: 3px;
            border-radius: 2px;
            background: #409EFF;
        }
    }

    ::v-deep .el-tabs__active-bar {
        display: none;
    }

    ::v-deep .el-tabs__nav-next,
    ::v-deep .el-tabs__nav-prev {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        background: rgba(255, 255, 255, 0.95);
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.2s ease;
        z-index: 10;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        &:hover {
            background: #fff;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        // &.is-disabled {
        //     opacity: 0.3;
        //     cursor: not-allowed;
        // }
    }

    ::v-deep .el-tabs__nav-prev {
        left: 4px;
    }

    ::v-deep .el-tabs__nav-next {
        right: 4px;
    }
}

.content-container {
    padding: 12px;
    background: #fff;
}

.sticker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
    gap: 8px;
    max-height: 180px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.sticker-item {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 5px;

    &:hover {
        background: #f0f8ff;
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.95);
    }
}

.sticker-image {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 4px;
}
</style>